module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/checklist_desktop-a3d6a1b2de0a77a883f3a1fa071760b6.png";